import type { Verdict } from "@haulsheet/core";

const LABELS: Record<Verdict, string> = {
  enter_rate: "Enter rate",
  you_keep: "You keep",
  take_it: "Take it",
  thin: "Thin",
  barely: "Barely",
  pass: "Pass",
};

export function VerdictCard({ verdict }: { verdict: Verdict }) {
  return (
    <div className={`verdict ${verdict}`} data-testid="verdict-card">
      {LABELS[verdict]}
    </div>
  );
}
